import { MetaRatingIcon } from "@/icons";
import { useLocation, useNavigate } from "react-router-dom";

import { BaseLandingPage } from "./BaseLandingPage/BaseLandingPage";
import { USPType } from "./BaseLandingPage/USP";

const optimalWaysToUpgradeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M0.75 5.56731L12 0.375L23.25 5.56731V9.77885L12 4.58654L0.75 9.77885V5.56731Z"
      fill="currentColor"
    />
    <path
      d="M0.75 12.4904L12 7.29808L23.25 12.4904V16.7019L12 11.5096L0.75 16.7019V12.4904Z"
      fill="currentColor"
    />
    <path
      d="M0.75 19.4135L12 14.2212L23.25 19.4135V23.625L12 18.4327L0.75 23.625V19.4135Z"
      fill="currentColor"
    />
  </svg>
);

const detectEvosIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M23.25 21.75C23.25 22.5784 22.5784 23.25 21.75 23.25H15.75V20.25H20.25V15.75H23.25V21.75Z"
      fill="currentColor"
    />
    <path
      d="M21.75 0.75C22.5784 0.75 23.25 1.42157 23.25 2.25V8.25H20.25V3.75H15.75V0.75H21.75Z"
      fill="currentColor"
    />
    <path
      d="M0.75 2.25C0.75 1.42157 1.42157 0.75 2.25 0.75H8.25V3.75H3.75V8.25H0.75V2.25Z"
      fill="currentColor"
    />
    <path
      d="M8.25 20.25V23.25H2.25C1.42157 23.25 0.75 22.5784 0.75 21.75V15.75H3.75V20.25H8.25Z"
      fill="currentColor"
    />
    <path d="M10.875 8.25H13.125V15.75H10.875V8.25Z" fill="currentColor" />
    <path d="M8.25 10.875H15.75V13.125H8.25V10.875Z" fill="currentColor" />
  </svg>
);

const USPs: USPType[] = [
  {
    icon: <MetaRatingIcon width="40" height="40" />,
    title: "Meta Ratings and Tiers",
    description: (
      <div className="w-84 mobile:w-100">
        See Meta Ratings and Tiers for all your evo cards, including expired
        evos
      </div>
    ),
  },
  {
    icon: detectEvosIcon,
    title: "Automatic Detection",
    description: (
      <div className="w-84 mobile:w-100">
        100% automatic detection of evo paths for current evo players using Club
        Import
      </div>
    ),
  },
  {
    icon: optimalWaysToUpgradeIcon,
    title: "Optimal Evo Chains",
    description: (
      <div>
        See the optimal way to upgrade your evo cards
        <br />
        when new Evolutions come out
      </div>
    ),
  },
];

export const MyEvolutionsLandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as LocationState)?.from || "/my-club";
  return (
    <BaseLandingPage
      heroTitle="EA FC 25 My Evolutions"
      pageTitle="Master Evolutions. Elevate your club"
      navigateBack={from}
      ctaTitle="Subscribe Now"
      USPs={USPs}
      onHandleCTA={() => {
        navigate("/subscription");
      }}
    >
      <img
        src={
          import.meta.env.VITE_APP_ASSETS_BASE_URL +
          "/fc25/my-club/my-evolutions/tstt.png"
        }
        className="absolute top-8 right-0 large-desktop:right-50 hidden mobile:block max-w-112 touch-device:max-w-200"
      />
    </BaseLandingPage>
  );
};
